import { useEffect, useState } from "react";
import Button from "../../shared/Button";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { useError } from "../../context/ErrorProvider";
import { useMutation } from "react-query";
import { resendIdentifier, verifyResetPassword } from "../../sdk/auth/auth";

const ResetPassword = () => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(30);
  const { showError } = useError();
  const resetIdentifier = localStorage.getItem("resetIdentifier")
    ? localStorage.getItem("resetIdentifier")
    : "";

  const { mutate: resendMutate } = useMutation({
    mutationKey: ["resent-password-otp"],
    mutationFn: () => resendIdentifier(resetIdentifier),
    onSuccess: () => {},
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const { mutate, isLoading } = useMutation({
    mutationKey: ["verify-reset-otp"],
    mutationFn: () => verifyResetPassword(resetIdentifier, otp),
    onSuccess: (data) => {
      if (data.status === 200 || data?.status === 201) {
        navigate("/update-password");
      }
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  useEffect(() => {
    if (secondsLeft === 0) return;

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const handleResendOtp = () => {
    setOtp("");
    setSecondsLeft(30);
    resendMutate();
  };
  return (
    <div className="h-full w-[80%] flex flex-col pb-[100px] justify-end">
      <p className="text-[#222222] font-semibold text-[24px]">Verify Code</p>
      <p className="text-[#5C5C5C] font-medium text-[13px]">
        Enter the 6-digit code sent to your registered mobile number.
      </p>
      <div className="w-full">
        <div className="flex flex-col my-[20px] gap-[5px]">
          <p className="text-[#000000] text-[14px] font-medium">
            One time password
          </p>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            shouldAutoFocus
            renderInput={(props) => (
              <input
                {...props}
                style={{
                  width: "50px",
                  height: "50px",
                  border: "2px solid #5C5C5C",
                }}
              />
            )}
            renderSeparator={<span className="mx-2" />}
            inputStyle="bg-white text-center text-[24px] rounded-[5px] text-[#000] border-[1px] border-[#000]"
          />
        </div>
        <div className="flex items-center justify-between my-[50px]">
          {secondsLeft === 0 ? (
            <p
              onClick={handleResendOtp}
              className="text-[#000000] underline text-[16px] font-normal cursor-pointer"
            >
              Resend OTP
            </p>
          ) : (
            <p className="text-[#5C5C5C] text-[16px] font-normal">
              Enter or paste the one time password
            </p>
          )}
          <p className="text-[#000000] font-semibold text-[15px]">
            00:{secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft}
          </p>
        </div>
        <div className="my-[20px] w-full">
          <Button
            label="Verify"
            isLoading={isLoading}
            disabled={isLoading}
            handleClick={mutate}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
